import React from 'react';
import { AdspotType } from '@domain-group/fe-allhomes-library';
import { AdSpot } from '@domain-group/fe-co-allhomes-ads';
import { jsx as ___EmotionJSX } from "@emotion/core";
var HomepageAdSpot = () => ___EmotionJSX(AdSpot, {
  gpt: {
    adId: AdspotType.ADSPOT_1x11_HOMEPAGE
  },
  adbridg: {
    id: 'adb-ah-hp-sponsorship'
  }
});
export default HomepageAdSpot;